import { useQuery } from "@tanstack/react-query";
import { useScopeParams } from "./useScopeParams";
import { alertsService } from "@/services/alertsService";
import { insightsService } from "@/services/insightsService";

export const useAlertsQuery = () => {
  const { id } = useScopeParams();

  const realQuery = useQuery({
    queryKey: ["alerts", id],
    queryFn: async () => {
      if (!id) return [];

      // Get insights first
      const latestInsights = await insightsService.getInsights(id);
      const insightsMap = new Map();
      latestInsights.forEach((insight: any) => {
        insightsMap.set(insight.id, insight);
      });

      // Fetch alerts
      const fetchedAlerts = await alertsService.getAlerts(id);

      const enrichedAlerts = fetchedAlerts
        .map((alertDetail: any) => {
          const fullInsight = insightsMap.get(alertDetail.insight_id);
          if (!fullInsight) {
            console.warn(
              `Insight data not found for alert id: ${alertDetail.id} (insight_id: ${alertDetail.insight_id})`,
            );
            return null;
          }
          return {
            ...alertDetail,
            insight: {
              id: fullInsight.id,
              category: fullInsight.category,
              cadence: fullInsight.cadence,
              title: fullInsight.title,
              av_question: fullInsight.av_question,
              av_answer: fullInsight.av_answer,
              trial: fullInsight.trial,
              is_archived: fullInsight.is_archived,
              is_deleted: fullInsight.is_deleted,
              is_shared: fullInsight.is_shared,
              last_run_at: fullInsight.last_run_at,
              created_at: fullInsight.created_at,
              updated_at: fullInsight.updated_at,
              insight_result_timestamp: fullInsight.insight_result_timestamp,
              alert: fullInsight.alert,
              selected_sources: fullInsight.selected_sources,
            },
          };
        })
        .filter((item: any) => item !== null);

      return enrichedAlerts;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: Infinity,
    retry: 2,
  });

  const query = realQuery;

  return {
    alerts: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
